import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import ApiService from "../_services/ApiService"

export const useDashboardData = () => {
  const [studioAnalyticData, setStudioAnalyticData] = useState(null)
  const [campaignDetails, setCampaignDetails] = useState([])
  const [collabRequest, setCollabRequest] = useState([])
  const [blogs, setBlogs] = useState([])
  const [officialPlaylists, setOfficialPlaylists] = useState([])
  const [loading, setLoading] = useState({
    stats: true,
    campaigns: true,
    collaborations: true,
    blogs: true,
    playlists: true,
  })

  const userData = useSelector((state) => state.userData.userData)

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch analytics data
        const analyticsRes = await ApiService.get("creatorAnalysisData")
        if ([200, 201].includes(analyticsRes.status)) {
          setStudioAnalyticData(analyticsRes.data)
        }
        setLoading((prev) => ({ ...prev, stats: false }))

        if (userData?.id) {
          // Fetch collaborations
          const collabRes = await ApiService.get("getCollabAcceptedRequest", { status: "" }, userData.id + "/")
          if ([200, 201].includes(collabRes.status)) {
            setCollabRequest(collabRes.data.results)
          }
          setLoading((prev) => ({ ...prev, collaborations: false }))

          // Fetch campaigns
          const campaignRes = await ApiService.get(
            "songPromotionCampaign",
            { search: userData.id, limit: 6, offset: 0 },
            "reelcampaign/user",
          )
          if (campaignRes.data) {
            setCampaignDetails(campaignRes.data.results)
          }
          setLoading((prev) => ({ ...prev, campaigns: false }))
        }

        // Fetch playlists
        const playlistRes = await ApiService.get("officalPlaylist", { limit: 5, offset: 0 })
        if ([200, 201].includes(playlistRes.status)) {
          const playlistResults = playlistRes.data.results ?? playlistRes.data

          const formattedPlaylists = playlistResults.map((playlist) => ({
            image: playlist.playlist_cover_image
              ? `${process.env.REACT_APP_BASEURL_MEDIA}/media/${playlist.playlist_cover_image}`
              : playlist.playlist_cover_image_url
                ? `${process.env.REACT_APP_BASEURL_MEDIA}/media/${playlist.playlist_cover_image_url}`
                : null,
            title: playlist.playlist_name,
            slug: playlist.slug,
            privacy_status: playlist.privacy_status,
            platforms: playlist.playlist_releated_platform
              ?.map((platform) => ({
                icon: "",
                link: platform.streamingPlatformlink,
              }))
              .filter((p) => p.icon && p.link),
          }))
          setOfficialPlaylists(formattedPlaylists)
        }
        setLoading((prev) => ({ ...prev, playlists: false }))

        // Fetch blogs
        const blogRes = await fetch("https://www.groovenexus.com/wp-json/wp/v2/posts/?per_page=10&page=1", {
          headers: { Authorization: `Bearer ${process.env.REACT_APP_TOKEN}` },
        })
        const blogData = await blogRes.json()
        const mappedBlogs = blogData?.data?.map((post) => ({
          image: post.featured_image_url,
          title: post.title,
          subtitle: post.content,
          avatar: post.author_avatar.url,
          author: post.author_name,
          date: post.date,
          link: post.link,
        }))
        setBlogs(mappedBlogs || [])
        setLoading((prev) => ({ ...prev, blogs: false }))
      } catch (error) {
        console.error("Dashboard data fetch error:", error)
        setLoading({
          stats: false,
          campaigns: false,
          collaborations: false,
          blogs: false,
          playlists: false,
        })
      }
    }

    fetchData()
  }, [userData])

  return {
    studioAnalyticData,
    campaignDetails,
    collabRequest,
    blogs,
    officialPlaylists,
    loading,
  }
}
